import {
    faAngleDown,
    faCoins,
    faFire,
    faHashtag,
    faSquareFull,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HashtagIcon = <FontAwesomeIcon icon={faHashtag} />;
export const FireIcon = <FontAwesomeIcon icon={faFire} />;
export const ArrowIcon = (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.76144 6.11102L1.15212 11L0 9.77797L4.03325 5.5L0 1.22203L1.15212 0L5.76144 4.88898C5.91419 5.05105 6 5.27083 6 5.5C6 5.72916 5.91419 5.94895 5.76144 6.11102Z"
            fill="white"
        />
    </svg>
);
export const CoinsIcon = <FontAwesomeIcon icon={faCoins} />;
export const CoinsIconWithMask = <FontAwesomeIcon mask={faSquareFull} icon={faCoins} />;
export const ArrowDownIcon = <FontAwesomeIcon icon={faAngleDown} />;

export const FilterIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.29354 1.29395C7.68416 0.90332 8.31854 0.90332 8.70916 1.29395L12.7092 5.29395C12.9967 5.58145 13.081 6.00957 12.9248 6.38457C12.7685 6.75957 12.406 7.00332 11.9998 7.00332L3.99979 7.0002C3.59666 7.0002 3.23104 6.75644 3.07479 6.38144C2.91854 6.00644 3.00604 5.57832 3.29041 5.29082L7.29041 1.29082L7.29354 1.29395ZM7.29354 14.7096L3.29354 10.7096C3.00604 10.4221 2.92166 9.99395 3.07791 9.61895C3.23416 9.24395 3.59666 9.0002 4.00291 9.0002H12.0029C12.406 9.0002 12.7717 9.24395 12.9279 9.61895C13.0842 9.99395 12.9967 10.4221 12.7123 10.7096L8.71229 14.7096C8.32166 15.1002 7.68729 15.1002 7.29666 14.7096H7.29354Z"
            fill="#111827"
        />
    </svg>
);
